<template>
  <RequestWizardStep name="Records Type" :complete="recordsType === 'Non-public records'">
    <ContentCard
      title="What type of records are you looking for?"
    >
      <AlertMessage type="warning"
        :show="recordsType === 'Personnel records'"
        title="Personnel records"
      >
        <p>
          Please note that requests for personnel records typically fall under the Privacy Act.
          The HRSA FOIA Office does not process Privacy Act requests. Please contact the
          Privacy Office at <a href="mailto:PrivacyAct@hrsa.gov">PrivacyAct@hrsa.gov</a>
          with your request.
        </p>
      </AlertMessage>

      <AlertMessage type="warning"
        :show="recordsType === 'Provider Relief Fund records'"
        title="Provider Relief Fund Records"
      >
        <p>
          Please note that the HRSA FOIA Office is not responsible for Provider Relief Fund
          information. Please see the
          <a href="https://www.hrsa.gov/provider-relief" target="_blank">PRF website</a>
          or the <a href="https://www.hrsa.gov/foia" target="_blank">HRSA FOIA website</a>
          for information concerning PR applications or any other PRF related materials.
        </p>
      </AlertMessage>

      <AlertMessage type="warning"
        :show="recordsType === 'Countermeasures Injury Compensation Program data'"
        title="Countermeasures Injury Compensation Program Data"
      >
        <p>
          Please note that Countermeasures Injury Compensation Program data is available through
          the HRSA FOIA Reading Room. Please navigate to
          <a href="https://www.hrsa.gov/cicp/cicp-data" target="_blank">HRSA's CICP Data</a>
          page to search for the required records.
          If the records you are seeking are not already available, then submit a request
          using the "Non-public records" option.
        </p>
      </AlertMessage>

      <AlertMessage type="warning"
        :show="recordsType === 'Public contracts'"
        title="Public contracts"
      >
        <p>
          Please note that basic contract information (e.g., Award Numbers, Recipients, Date Ranges,
          Award Amounts, and Descriptions) is already available on the USASpending.gov website.
          Please visit the <a href="https://www.usaspending.gov/" target="_blank">USASpending.gov website</a>
          and search for your desired information on contracts before submitting a FOIA request.
        </p>
      </AlertMessage>

      <AlertMessage type="warning"
        :show="recordsType === 'Public grants'"
        title="Public grants"
      >
        <p>
          Please note that basic grant information (e.g., Program Area, Fiscal Year, Grant Numbers,
          States, Award Amounts, Grantee Contact Details, etc.) is publicly available on HRSA's
          website.
          Please visit the <a href="https://data.hrsa.gov/tools/find-grants" target="_blank">HRSA Grants Database</a>
          and search for your desired information on grants before submitting a FOIA request.
        </p>
      </AlertMessage>

      <ReflectAttrs
        v-bind="{ recordsTypeLabel: 'I am looking for' }"
        v-slot="{ recordsTypeLabel }"
      >
        <div>
          <p class="lead">{{ recordsTypeLabel }}:</p>

          <StepSelection>
            <RadioButtons
              :aria-label="recordsTypeLabel"
              :options="[
                'Personnel records',
                'Provider Relief Fund records',
                'Countermeasures Injury Compensation Program data',
                'Public contracts',
                'Public grants',
                {
                  value: 'Non-public records',
                  label: 'Non-public records (e.g., reports, grant applications, contract '
                    + 'proposals, correspondence, emails, calendars, presentation materials, etc.)'
                }
              ]"
              v-model="recordsType"
            />
          </StepSelection>
        </div>
      </ReflectAttrs>
    </ContentCard>
  </RequestWizardStep>
</template>

<script>
import AlertMessage from '@/components/AlertMessage';
import RadioButtons from '@/components/formFields/RadioButtons';
import RequestWizardStep from '@/components/requestWizard/RequestWizardStep';
import StepSelection from '@/components/requestWizard/StepSelection';

export default {
  components: {
    AlertMessage, RadioButtons, RequestWizardStep, StepSelection
  },

  data: () => ({
    recordsType: null
  })
};
</script>
